<template>
  <Card class="mb-4">
    <template #header>
      <h2 class="mb-0">Tarifdaten</h2>
    </template>
    <div>

      <!-- base-input rules="required" name="Versicherungsumfang">
              <el-select
                v-model="offer.participation"
                filterable
                placeholder="Versicherungsumfang"
              >
                <el-option
                  v-for="option in offer.participations"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </base-input -->




      <div>
        <h4>Kaskotyp</h4>
        <div class="d-flex">
          <div class="mr-4">
            <input type="radio" id="kaskotyp_ohne" value="Ohne" v-model="offer.softfair_kaskotyp" class="mr-2" />
            <label for="kaskotyp_ohne">Ohne</label>
          </div>
          <div class="mr-4">
            <input type="radio" id="kaskotyp_teilkasko" value="Teilkasko" v-model="offer.softfair_kaskotyp"
              class="mr-2" />
            <label for="kaskotyp_teilkasko">Teilkasko</label>
          </div>
          <div>
            <input type="radio" id="kaskotyp_vollkasko" value="Vollkasko" v-model="offer.softfair_kaskotyp"
              class="mr-2" />
            <label for="kaskotyp_vollkasko">Vollkasko</label>
          </div>
        </div>
      </div>


      <div>
        
        <b-row>
          <b-col md="6">
            <h4>Schadenfreiheitsklasse Haftpflicht</h4>
            <base-input prepend-icon="fas fa-user" placeholder="SF KH"
              v-model="offer.softfair_schadenfreiheitsklasse_haftpflicht" name="SF Haftpflicht"
              :rules="{ required: true, max: 4, regex: /[a-zA-Z0-9]+/ }"></base-input>
          </b-col>

          <b-col md="6" v-if="show_sfr_2">
            <h4>Schadenfreiheitsklasse Kasko</h4>
            <base-input prepend-icon="fas fa-user" placeholder="SF Kasko"
              v-model="offer.softfair_schadenfreiheitsklasse_vollkasko" name="SF Kasko"
              :rules="{ required: true, max: 3, regex: /[a-zA-Z0-9]+/ }"></base-input>
          </b-col>
        </b-row>


        <b-row>
          <b-col md="6">
            <h4>Versicherungsbeginn</h4>
            <base-input prepend-icon="fas fa-calendar" v-model="offer.softfair_versicherungsbeginn" type="date" name="Versicherungsbeginn" rules="required" placeholder="DD.MM.YYYY"></base-input>
          </b-col>

          <b-col md="6" v-if="show_sfr_2">
            <BaseSelect v-model="offer.softfair_selbstbeteiligung_kasko" :options="selbstbeteiligungKaskoOptions"
            label="Selbstbeteiligung Kasko" />
          </b-col>
        </b-row>



      </div>


      <b-row>
        <b-col lg="6">
          <h4 @click="toggleOptional()">Optional</h4>
        </b-col>
        <b-col lg="6" class="text-right">
          <i v-if="show_optional" class="fa fa-chevron-down" @click="toggleOptional()"></i>
          <i v-else class="fa fa-chevron-left" @click="toggleOptional()"></i>
        </b-col>
      </b-row>


      <div v-if="show_optional">

        <b-row>
          <b-col md="6">
            <BaseSelect v-model="offer.softfair_zahlungs_art_und_weise" :options="zahlungsArtOptions"
        label="Zahlungsart und Weise" />
          </b-col>

          <b-col md="6" v-if="show_sfr_2">
            <BaseSelect v-model="offer.softfair_finanzierung" :options="finanzierungOptions" label="Finanzierung" />
          </b-col>
        </b-row>

        <BaseCheckbox v-model="offer.softfair_hauptfaelligkeit_unterjaehrig"
        :checked="offer.softfair_hauptfaelligkeit_unterjaehrig" :inline="true">Hauptfälligkeit unterjährig
      </BaseCheckbox>

      <BaseCheckbox v-model="offer.softfair_rueckstufung_beruecksichtigen"
        :checked="offer.softfair_rueckstufung_beruecksichtigen" :inline="true">Rückstufung berücksichtigen
      </BaseCheckbox>


      <BaseSelect v-model="offer.softfair_geschaeftsvorfall" :options="geschaeftsvorfallOptions"
        label="Geschäftsvorfall" />


      </div>


    </div>
  </Card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BaseInput from '@/components/Inputs/BaseInput.vue';
import BaseCheckbox from '@/components/Inputs/BaseCheckbox.vue';
import BaseSelect from '@/components/Inputs/BaseSelect.vue';
import CscDateInput from '@/components/Inputs/CscDateInput.vue';
import Card from '@/components/Cards/Card.vue';

export default {
  name: "softfair-tarifdaten",
  components: {
    BaseInput,
    BaseCheckbox,
    BaseSelect,
    CscDateInput,
    Card,
  },
  data() {
    return {
      loading: false,
      show_optional: false,
      kaskotypOptions: ['Ohne', 'Teilkasko', 'Vollkasko'],
      zahlungsArtOptions: ['LastschriftJaehrlich', 'LastschriftHalbjaehrlich', 'LastschriftVierteljaehrlich', 'LastschriftMonatlich', 'UeberweisungJaehrlich', 'UeberweisungHalbjaehrlich', 'UeberweisungVierteljaehrlich', 'UeberweisungMonatlich'],
      geschaeftsvorfallOptions: ['VersichererwechselMitNeuemFahrzeugOderFahrzeugwechsel', 'VersichererwechselOhneFahrzeugwechsel', 'Neuanmeldung', 'Verlaengerung'],
      sfOptions: ['SF0', 'SF1', 'SF2', 'SF3', 'SF4', 'SF5', 'SF6', 'SF7', 'SF8', 'SF9', 'SF10', 'SF11', 'SF12', 'SF13', 'SF14', 'SF15', 'SF16', 'SF17', 'SF18', 'SF19', 'SF20', 'SF21', 'SF22', 'SF23', 'SF24', 'SF25', 'SF26', 'SF27', 'SF28', 'SF29', 'SF30'],
      finanzierungOptions: ['Eigenfinanzierung', 'Finanzierung', 'Leasing'],
      selbstbeteiligungKaskoOptions: ['VkohneTkohne', 'Vk150Tk150', 'Vk300Tk150', 'Vk500Tk150', 'Vk750Tk150', 'Vk1000Tk150', 'Vk2500Tk150', 'Vk5000Tk150', 'Vk750Tk750', 'Vk1000Tk750', 'Vk150Tkohne', 'Vk300Tkohne', 'Vk500Tkohne', 'Vk750Tkohne', 'Vk1000Tkohne', 'Vk2500Tkohne', 'Vk5000Tkohne'],
    };
  },
  methods: {
    setDefaults() {
    },
    financial(x) {
      if (isNaN(Number.parseFloat(x).toFixed(2))) {
        return 0;
      }
      return Number.parseFloat(x).toFixed(2);
    },
    toggleOptional() {
      this.show_optional = !this.show_optional;
    }
  },
  computed: {
    ...mapGetters({
      currentAccount: "currentAccount",
    }),
    ...mapState({
      account: state => state.account,
      offer: (state) => state.softfairOffer,
    }),
    show_sfr_2() {
      if (this.offer.softfair_kaskotyp == 'Vollkasko') {
        return true;
      }
      if (this.offer.softfair_kaskotyp == 'Teilkasko') {
        return true;
      }
      return false;
    },
  },
  mounted() {
  },
};
</script>
<style></style>